// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlidersTwoToneSvg from "@fishx/icons-svg/es/asn/SlidersTwoTone";
import FishxIcon from '../components/FishxIcon';

var SlidersTwoTone = function SlidersTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlidersTwoToneSvg
  }));
};

SlidersTwoTone.displayName = 'SlidersTwoTone';
export default React.forwardRef(SlidersTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SlidersTwoTone.js
// module id = 4154
// module chunks = 0